import React, { JSX } from "react";
import { GenericFieldProps } from "./fieldProps";

export type HiddenFieldProps = GenericFieldProps<string>;

export const HiddenField = ({ value }: HiddenFieldProps): JSX.Element => {
  return <input type="hidden" value={value}></input>;
};

export const hiddenField = {
  renderer: HiddenField,
  equals: (a: string, b: string): boolean => {
    return a === b;
  },
};
